import React from "react";
import "./TestimonialsGrid.css";
import avatar1 from "../assets/images/text1.jpg";
import avatar2 from "../assets/images/test2.jpg";
import avatar3 from "../assets/images/text3.jpg";
import avatar4 from "../assets/images/text4.jpg";
import avatar5 from "../assets/images/test5.jpg";
import avatar6 from "../assets/images/test6.jpg";
import avatar7 from "../assets/images/test7.jpg";
import avatar8 from "../assets/images/test8.jpg";
import avatar9 from "../assets/images/test9.jpg";
import avatar10 from "../assets/images/goutam.jpg";

const testimonials = [
  { avatar: avatar10, name: "Goutam Gurjar", role: "Student (Mern Developer)", rating: 5, testimonial: "Cool environment, and employees are very supportive. This training and internship program made me more confident about my skills than before." },
  { avatar: avatar1, name: "Kratagya Sharma", role: "Student (Medicaps)", rating: 4, testimonial: "The staff has been very supportive since our training + internship program began. The mentor assigned (Aman sir) is very supportive and solved all kinds of doubts. It's a great experience with CoderWing." },
  { avatar: avatar3, name: "Kushal Rathore", role: "Student (Medicaps)", rating: 5, testimonial: "Learned many new things, not only technical like React, HTML, CSS, Bootstrap, and Node.js but also soft skills like communication and job seeking. Placed – In TCS." },
  { avatar: avatar4, name: "Mili Singh Mourya", role: "Frontend Developer", rating: 4, testimonial: "Learned a lot about cooperative working and technical skills. The atmosphere is great with understanding and flexibility." },
  { avatar: avatar5, name: "Isha Kanoongo", role: "Student (Medicaps)", rating: 5, testimonial: "I had a very good experience in this company. Trainers are well-trained and provided me with the best knowledge. Highly recommend it!" },
  { avatar: avatar6, name: "Nilesh Parihar", role: "Web Developer", rating: 4, testimonial: "Overall experience was good. The office culture and work environment at CoderWing are also great." },
  { avatar: avatar7, name: "Nadiv Londhe", role: "Student (Medicaps)", rating: 4, testimonial: "Nice experience. The technical and cooperative guidance provided was very helpful. I got to add new skills to my knowledge because of CoderWing." },
  { avatar: avatar8, name: "Muskan Yadav", role: "Full Stack Developer", rating: 5, testimonial: "CoderWing provides the best platform for internships and training. We learned many new technologies. This training made me more confident about my skills." },
  { avatar: avatar9, name: "Muskan Nayak", role: "Student (Medicaps)", rating: 5, testimonial: "Cool environment, and employees are very supportive. This training and internship program made me more confident about my skills than before." },
];

function TestimonialsGrid() {
  return (
    <section className="container">
      <h2>Student's Voice</h2>
      <div className="testimonials-grid">
        {testimonials.map((testimonial, index) => (
          <div key={index} className="testimonial-card">
            <img
              src={testimonial.avatar}
              alt={`${testimonial.name}'s Avatar`}
              className="testimonial-avatar"
            />
            <div className="testimonial-name">{testimonial.name}</div>
            <div className="testimonial-role">{testimonial.role}</div>
            <div className="testimonial-rating" style={{ color: "gold", fontSize: "24px" }}>
              {"★".repeat(testimonial.rating) + "☆".repeat(5 - testimonial.rating)}
            </div>
            <p className="testimonial-text">{testimonial.testimonial}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default TestimonialsGrid;